import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'seo-related_searches_explore_linking_renovation-click';
/**
 * Click tracker for related searches pill click. This is for the Explore Linking Renovations project, which adds (related) search terms to brand pages that link to Explore pages that correspond to the search terms.
 */
export function trackSeoRelatedSearchesExploreLinkingRenovationClick(Search_Term) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { Search_Term },
    });
}
